export default __webpack_public_path__ + "static/media/boxslogan.c42931fb.png";